import type { SVGProps } from "react";
const SvgIconConditions = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M629 454H395a12 12 0 0 1 0-24h234a12 12 0 0 1 0 24M629 522H395a12 12 0 0 1 0-24h234a12 12 0 0 1 0 24M629 652H395a12 12 0 0 1 0-24h234a12 12 0 0 1 0 24M629 586H395a12 12 0 0 1 0-24h234a12 12 0 0 1 0 24" />
    <path d="m700.84 359.16-100-100a12.5 12.5 0 0 0-8.84-3.66H357a37.54 37.54 0 0 0-37.5 37.5v438a37.54 37.54 0 0 0 37.5 37.5h310a37.54 37.54 0 0 0 37.5-37.5V368a12.54 12.54 0 0 0-3.66-8.84m-96.34-61 57.32 57.32H604.5ZM667 743.5H357a12.52 12.52 0 0 1-12.5-12.5V293a12.52 12.52 0 0 1 12.5-12.5h222.5V368a12.5 12.5 0 0 0 12.5 12.5h87.5V731a12.52 12.52 0 0 1-12.5 12.5" />
  </svg>
);
export default SvgIconConditions;
